export const COST_GRID_COLUMNS = [
  { field: "date", title: "date", width: 120 },
  { field: "title", title: "title", width: 200 },
  { field: "project", title: "project", width: 150 },
  { field: "origin", title: "origin", width: 160 },
  { field: "provider", title: "provider", width: 180 },
  { field: "subtotal", title: "subtotal", width: 100 },
  { field: "total", title: "total", width: 100 },
  { field: "expense_type", title: "type", width: 100 },
  { field: "is_direct", title: "nature", width: 120 },
  { field: "allocated", title: "allocated", width: 100 },
  { field: "files", title: "documents", width: 150 },
  { field: "actions", title: "actions", width: 100 },
]

export const costTypes = [
  "material",
  "machineryAndAuxiliaryMeans",
  "labor",
  "subcontract",
  "indirectCosts",
  "additionalWasteComponents",
  "wasteClassification",
  "unclassified",
  "other",
]

export const imputadoTypes = ["yes", "no", "partial"]

export const taxTypes = ["21%", "10%", "exempt"]

export const retentionTypes = ["1%", "3%", "exempt"]
